export enum ActionTypes {
  ROUTING_REQUEST = 'ROUTING_REQUEST',
  ROUTING_FAILED = 'ROUTING_FAILED',
  ROUTING_SUCCEEDED = 'ROUTING_SUCCEEDED',

  EDIT_ROUTE_REQUEST = 'EDIT_ROUTE_REQUEST',
  EDIT_ROUTE_FAILED = 'EDIT_ROUTE_FAILED',
  EDIT_ROUTE_SUCCEEDED = 'EDIT_ROUTE_SUCCEEDED',

  DELETE_ROUTES_REQUEST = 'DELETE_ROUTES_REQUEST',
  DELETE_ROUTES_FAILED = 'DELETE_ROUTES_FAILED',
  DELETE_ROUTES_SUCCEEDED = 'DELETE_ROUTES_SUCCEEDED',

  IMPORT_ACTIVITIES_SPREADSHEET_REQUEST = 'IMPORT_ACTIVITIES_SPREADSHEET_REQUEST',
  IMPORT_ACTIVITIES_SPREADSHEET_FAILED = 'IMPORT_ACTIVITIES_SPREADSHEET_FAILED',
  IMPORT_ACTIVITIES_SPREADSHEET_SUCCEEDED = 'IMPORT_ACTIVITIES_SPREADSHEET_SUCCEEDED',

  PARSE_SPREADSHEET_REQUEST = 'PARSE_SPREADSHEET_REQUEST',
  PARSE_SPREADSHEET_FAILED = 'PARSE_SPREADSHEET_FAILED',
  PARSE_SPREADSHEET_SUCCEEDED = 'PARSE_SPREADSHEET_SUCCEEDED',
}
